import type { SVGProps } from 'react';
const DawnFlagCOC = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <rect width={22} height={16} fill="#fff" rx={2} />
    <mask
      id="dawn-flag-COC_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect width={22} height={16} fill="#fff" rx={2} />
    </mask>
    <g mask="url(#dawn-flag-COC_svg__a)">
      <path fill="#19BFBF" d="M0 0h22v16H0z" />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M10.589 2.667a.33.33 0 0 0-.203.068l-1.951 1.49a.3.3 0 0 1-.12.058l-1.993.508a.3.3 0 0 0-.07.026l-1.963 1a.33.33 0 0 0-.148.15l-.914 1.862a.33.33 0 0 0 .02.33l.889 1.358a.33.33 0 0 1 .054.182v1.365c0 .087.035.17.096.233l.78.795c.103.104.26.13.39.064l2.854-1.453a.33.33 0 0 1 .15-.036h1.894c.079 0 .155.028.215.079l2.957 2.508c.06.051.136.08.215.08h1.793a.33.33 0 0 0 .279-.151l1.942-2.966a.33.33 0 0 0 .054-.183V8.099a.33.33 0 0 0-.054-.182L15.715 4.8l-1.476-2.503a.33.33 0 0 0-.287-.164h-.28a.242.242 0 0 0-.173.411c.072.074.09.184.044.276l-.356.727a.33.33 0 0 1-.3.186h-1.156a.33.33 0 0 1-.299-.186l-.34-.694a.33.33 0 0 0-.3-.186zm4.601 11.2h-1.047l.286.29c.13.134.345.134.475 0z"
        clipRule="evenodd"
      />
    </g>
  </svg>
);
export default DawnFlagCOC;
